import { environment } from 'src/environments/environment';

/**
 * Whether this URL is our own API, matched on a path boundary.
 *
 * The single home for that question. Every interceptor that attaches a first-party header has to
 * answer it, and each one that answers it on its own gets it subtly wrong: a bare
 * `startsWith(apiUrl)` also matches a host that merely *begins* with ours —
 * `https://our-api.example.app.evil.com` — so any header scoped that way is handed to whoever
 * registers that domain. `environment.apiUrl` carries no trailing slash, so the character after the
 * prefix has to be a path, query or fragment delimiter, or the URL has to end there.
 *
 * @param url - The outgoing request URL, absolute or relative
 * @returns `true` when the URL addresses `environment.apiUrl` itself or a path under it
 */
export function targetsOurApi(url: string): boolean {
  const base = environment.apiUrl?.replace(/\/+$/, '');
  if (!base || !url.startsWith(base)) {
    return false;
  }
  const remainder = url.slice(base.length);
  return remainder === '' || ['/', '?', '#'].includes(remainder[0]);
}
